import survey from './survey'
 

const api = {
    survey
}
export default api
